module.exports = __webpack_public_path__ + "img/garden.a4b76bbb.svg";